<template>
    <stats-card :title="title"
                :type="'gradient-'+type"
                :sub-title="closedIncidents.toString()"
                :icon="showHeader ? '' : 'fad fa-badge-check'"
                class="mb-4 mb-xl-0">
        <template v-slot:header v-if="showHeader">
            <router-link :to="{ name: 'Incidents' }" class="router-link">
                <div class="row align-items-center">
                    <div class="col">
                        <h6 class="text-uppercase text-muted ls-1 mb-1">Servicedesk</h6>
                    </div>
                    <div class="col-auto">
                        <div class="icon icon-shape"><i class="fad fa-tasks text-success" aria-hidden="true"></i></div>
                    </div>
                </div>
            </router-link>
            <hr class="mb-3 mt-1">
        </template>
            <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        <template v-slot:footer>
            <!--            <span class="text-danger mr-2">{{ overdueIncidents }}</span>
                        <span class="text-nowrap">{{ overdue }}</span>-->
        </template>
    </stats-card>
</template>
<script>
import {ref, onMounted} from 'vue';
import UserService from '@/services/user.service';
import moment from 'moment';

export default {
    name: 'IncidentsClosed',
    components: {},
    props: {
        type: {
            type: String,
            default: "green"
        },
        overdue: {
            type: String,
            default: "davon überfällig"
        },
        title: {
            type: String,
            default: "Geschlossene Fälle"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        let start = new Date();
        start.setUTCHours(0, 0, 0, 0);
        let end = new Date();
        end.setUTCHours(23, 59, 59, 999);

        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        const closedIncidents = ref(0);
        const overdueIncidents = ref(0);

        function getClosedIncidents() {
            UserService.getIncidents(0, 10000, null, true).then(
                response => {
                    closedIncidents.value = response.data.recordsTotal;
                    overdueIncidents.value = response.data.data.filter(item => {
                        return moment(item.targetDate) < moment();
                    }).length;
                },
                error => {
                    getError(error);
                }
            );
        }

        onMounted(() => {
            getClosedIncidents();
        });

        return {
            error,
            closedIncidents,
            overdueIncidents
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}
</style>
